<template>
    <div class="li_author" @click="onClickUser">
        <div class="author--pic img--wrapper">
            <img v-if="authorImage" :src="authorImage" :alt="nickName">
            <img v-else src="//d1ev.com/special/player/images/logo-d1ev-app.png" :alt="nickName">
            <div class="author_type img--wrapper">
                <img v-if="userTypeToString==='1'" src="//www.d1ev.com/static/home/search/images/author-tip-1.png" alt="">
                <img v-else-if="userTypeToString==='2'" src="//www.d1ev.com/static/home/search/images/author-tip-2.png" alt="">
            </div>
        </div>
        <div class="author-info">
            {{nickName}}
            <div class="info_tip" v-if="tags">
                {{tags}}
            </div>
        </div>
    </div>
</template>
<script>
  export default {
    name: "authorImg",
    data () {
      return {};
    },
    props: {
      headImg: {
        type: String,
        default: ""
      },
      userId: {
        type: String,
        default: ""
      },
      nickName: {
        type: String,
        default: "佚名"
      },
      userType: {
        type: [String, Number],
        default: ""
      },
      source: {
        type: [String, Number],
        default: "1"
      },
      tags: {
        type: [String],
        default: ""
      }
    },
    computed: {
      authorImage () {
        const _source = this.source;
        const _headImg = this.headImg;
        if (_headImg) {
          if ((_source === "1" || _source === "3") && _headImg.indexOf("/d/file/") !== -1) {
            return "https://cdn-fs.d1ev.com" + _headImg + "!88x88";
          } else if (_source === "2" && _headImg.indexOf("http") === -1) {
            return "//cdz.evcharge.cc/zhannew/uploadfile/" + _headImg;
          } else {
            return _headImg;
          }
        } else {
          return "";
        }
      },
      userTypeToString () {
        if (this.userType) {
          return this.userType.toString();
        }
      }
    },
    methods: {
      onClickUser () {
        const _source = this.source;
        const _userId = this.userId;
        if (_source && _userId && _source === "1" || _source && _userId && _source === "3") {
          this.$router.push({
            path: "/user/" + _userId
          });
        }
      },
    }
  };
</script>
<style lang="less">
    .li_author {
        max-width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        & .author--pic {
            display: inline-block;
            vertical-align: -0.18em;
            width: 30px;
            height: 30px;
            margin-right: 8px;
            position: relative;
            & img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
            }
            & .author_type {
                position: absolute;
                right: 0;
                bottom: 0;
                display: inline-block;
                vertical-align: -0.18em;
                width: 12px;
                height: 12px;
                border-radius: 50%;
                overflow: hidden;
                margin-left: 5px;
                margin-top: -2px;
            }
        }
        & .author-info {
            font-size: inherit;
            color: inherit;
            line-height: inherit;
            max-width: 18em;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            & .info_tip {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #9B9B9B;
                margin-top: 8px;
                white-space: nowrap;
                max-width: 30em;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }
</style>